import { render, staticRenderFns } from "./AxCodeSelectDialog.vue?vue&type=template&id=1b048b94&scoped=true"
import script from "./AxCodeSelectDialog.vue?vue&type=script&lang=ts"
export * from "./AxCodeSelectDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxCodeSelectDialog.vue?vue&type=style&index=0&id=1b048b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b048b94",
  null
  
)

export default component.exports